import React, { useState } from 'react';
import Layout from '../components/Layout';
import LineSeperator from '../components/ui/LineSeperator';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaClock } from 'react-icons/fa';
import '../stylings/ContactUs.css';

export default function ContactUs() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', subject: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    // [PLACEHOLDER: Connect to backend API for form submission]
    setSubmitted(true);
  };

  return (
    <Layout bannerTitle="Contact Us">
      <section className="inner-page-section">
        <div className="container-fluid px-5">
          <LineSeperator title="Get In Touch" />
          <div className="row g-5 mt-2">
            {/* Contact Info */}
            <div className="col-lg-4">
              <div className="contact-info-card">
                <div className="contact-info-item">
                  <FaMapMarkerAlt className="ci-icon" />
                  <div>
                    <h6>Address</h6>
                    <p>Baljeet Vihar, Nithari Extn. Near Rohini Sec-22, New Delhi-110086</p>
                  </div>
                </div>
                <div className="contact-info-item">
                  <FaPhone className="ci-icon" />
                  <div>
                    <h6>Phone</h6>
                    <p><a href="tel:9999355051">9999355051</a></p>
                    <p><a href="tel:9211101997">9211101997</a></p>
                  </div>
                </div>
                <div className="contact-info-item">
                  <FaEnvelope className="ci-icon" />
                  <div>
                    <h6>Email</h6>
                    <p><a href="mailto:akashmodelschool5051@gmail.com">akashmodelschool5051@gmail.com</a></p>
                  </div>
                </div>
                <div className="contact-info-item">
                  <FaClock className="ci-icon" />
                  <div>
                    <h6>School Hours</h6>
                    <p>Mon – Sat: 8:00 AM – 3:00 PM</p>
                    <p>Sunday: Closed</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="col-lg-8">
              {submitted ? (
                <div className="contact-success-msg">
                  <i className="fas fa-check-circle fa-3x mb-3"></i>
                  <h4>Thank You!</h4>
                  <p>Your message has been sent. We will get back to you shortly.</p>
                  <button className="btn btn-primary mt-3" onClick={() => setSubmitted(false)}>Send Another</button>
                </div>
              ) : (
                <form className="contact-form" onSubmit={handleSubmit}>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <input type="text" name="name" className="form-control" placeholder="Your Name *" value={form.name} onChange={handleChange} required />
                    </div>
                    <div className="col-md-6">
                      <input type="email" name="email" className="form-control" placeholder="Your Email *" value={form.email} onChange={handleChange} required />
                    </div>
                    <div className="col-md-6">
                      <input type="tel" name="phone" className="form-control" placeholder="Phone Number" value={form.phone} onChange={handleChange} />
                    </div>
                    <div className="col-md-6">
                      <input type="text" name="subject" className="form-control" placeholder="Subject *" value={form.subject} onChange={handleChange} required />
                    </div>
                    <div className="col-12">
                      <textarea name="message" className="form-control" rows="5" placeholder="Your Message *" value={form.message} onChange={handleChange} required></textarea>
                    </div>
                    <div className="col-12">
                      <button type="submit" className="contact-submit-btn">
                        <i className="fas fa-paper-plane me-2"></i>Send Message
                      </button>
                    </div>
                  </div>
                </form>
              )}
            </div>
          </div>

          {/* Map */}
          <div className="contact-map-wrapper mt-5">
            <h5 className="map-heading"><i className="fas fa-map-marked-alt me-2"></i>Find Us on Map</h5>
            <div className="map-embed-placeholder">
              <iframe
                title="School Location"
                src="https://maps.google.com/maps?cid=3332110853077635998&output=embed&hl=en&gl=IN"
                width="100%"
                height="350"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
